import { useMakeDefaultBrandApi } from "brand/api";
import LinkButton from "components/buttons/LinkButton";
import OptionsPanel from "components/panels/OptionsPanel";
import React from "react";
import { Button } from "semantic-ui-react";
import { routes } from "utilities/routing/generatedRoutes";
import { DeleteDialog, Modal } from "../../components";
import OptionsPanelFooter from "../../components/optionspanel/OptionsPanelFooter";

interface Props {
  optionsPanelData: server.dto.OptionsPanelDataV2
  listUrl: string
  brand: server.dto.Brand
}

const BrandOptionsPanel = (props: Props) => {
  const [isDeleting, setIsDeleting] = React.useState<boolean>(false);
  const [isMakingDefault, setIsMakingDefault] = React.useState<boolean>(false);

  const onDelete = async () => {
    const res = await window.CoreApi.Brand.DeleteBrand(props.brand.brandId);

    if (res.data.hasErrors) {
      window.displayGenericModal(RESX.GeneralLabels.Delete, res.data.errors[0].message, "mini", "error");
    } else {
      window.location.href = props.listUrl;
    }
    setIsDeleting(false);
  };

  const makeDefaultApi = useMakeDefaultBrandApi();

  const onMakeDefault = async () => {
    await makeDefaultApi.mutateAsync(props.brand.brandId);
    setIsMakingDefault(false);
  };

  return <OptionsPanel title={RESX.OptionsPanel.Options}>
    {props.brand.clientDefault && <div className="content-section margin-bottom-large">
      Default brand
    </div>}

    {!props.brand.clientDefault && <div className="margin-bottom-large">
      <Button
        fluid
        color="blue"
        type="button"
        onClick={() => { setIsMakingDefault(true); }}
      >Make default brand</Button>
    </div>}

    <div className="margin-bottom-large">
      <Button
        fluid
        color="red"
        type="button"
        onClick={() => { setIsDeleting(true); }}
      >{RESX.Buttons.btnDelete}</Button>
    </div>

    <div className="margin-bottom-large">
      <LinkButton
        fluid
        text={RESX.Buttons.ListView}
        type="primary"
        href={routes.brand_List().absolute}
      />
    </div>

    {props.brand && <OptionsPanelFooter
      optionsPanelData={props.optionsPanelData}
    />}

    <DeleteDialog
      isOpen={isDeleting}
      onDelete={onDelete}
      handleClose={() => { setIsDeleting(false); }}
      message={RESX.GeneralWarnings.DeleteSure}
    />

    <Modal
      isOpen={isMakingDefault}
      handleClose={() => { setIsMakingDefault(false); }}
      title={"Make default"}
    >
      <div className="grow1">
        {RESX.GeneralWarnings.AreYouSure}
      </div>

      <div className="flex">
        <div className="grow1"></div>
        <Button
          primary
          onClick={onMakeDefault}
          loading={makeDefaultApi.isLoading}
          disabled={makeDefaultApi.isLoading}>
          {RESX.Buttons.BtnOk}
        </Button>
      </div>
    </Modal>
  </OptionsPanel>;
};

export default BrandOptionsPanel;